import { IContentItemUserValidation } from 'redhotpie-shared-lib/interfaces/ICommunity';
import * as utils from '../functions/utils';
import owner from './owner';
import { IActor, IUserValidationData } from 'redhotpie-shared-lib/interfaces/INewFeed';

export default class UserValidation {
  description: string;
  owner: IActor;
  parentType: string;
  actor: IActor;
  dateCreated: number | string | undefined;

  constructor() {
    this.description = '';
    this.owner = {};
    this.parentType = '';
    this.actor = {};
    this.dateCreated = '';
  }

  static mappingObject(_obj: IUserValidationData): IContentItemUserValidation {
    let obj = Object.assign(new UserValidation(), _obj);
    obj.description = _obj.Message || '';
    obj.owner = _obj.Owner ? owner.mappingObject(_obj.Owner) : {};
    obj.parentType = _obj?.ParentType || '';
    obj.dateCreated = _obj?.DateCreated || '';
    obj.actor = _obj.Provider ? owner.mappingObject(_obj.Provider) : {};
    obj = utils.cleanObjectKeys(Object.keys(new UserValidation()), obj);
    return obj;
  }

  static mappingArray(_arr: IUserValidationData[]): IContentItemUserValidation[] {
    return _arr.map(element => this.mappingObject(element));
  }
}
